import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { TimelineSection as Original } from 'components/organisms'
import { TimelineSectionSettings } from './TimelineSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { timelineCardItemParams } from '../TimelineCard'

export const defaultProps = {}

export const dynamicProps = []

export const TimelineSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )
    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-timeline-section ${props.className}`}>
        <Original
          item={{
            pk: id,
            name: getTextEditor(children?.[0], enabled),
            children: getItemChildren(enabled, children?.[1], timelineCardItemParams),
          }}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

TimelineSection.craft = withCraft({
  name: 'TimelineSection',
  defaultProps: defaultProps,
  settings: TimelineSectionSettings,
})
